import React from 'react';
import PropTypes from "prop-types";
import {Outlet} from "react-router-dom";

import Footer from "./Footer";
import Loader from "./Loader";
import CustomToast from "../components/CustomToast";

import './layouts.scss';

function BasicLayout({with_footer = true, with_loader = true}) {
    function renderFooter() {
        if (with_footer) {
            return <Footer/>;
        }

        return null;
    }

    function renderLoader() {
        if (with_loader) {
            return <Loader/>;
        }

        return null;
    }

    return (
        <>
            <CustomToast/>
            <div id='full-layout'>
                <Outlet/>
            </div>
            {renderFooter()}
            {renderLoader()}
        </>
    )
}

BasicLayout.propTypes = {
    with_footer: PropTypes.bool,
    with_loader: PropTypes.bool
};

export default BasicLayout
